import {SiteConfigContextValue} from './site-config-context';
import {message} from '../../i18n/message';

export const BaseSiteConfig: SiteConfigContextValue = {
  auth: {
    redirectUri: '/',
    adminRedirectUri: '/admin',
  },
  tags: {
    types: [{name: 'custom'}],
  },
  customPages: {
    types: [{type: 'default', label: message('Default')}],
  },

  homepage: {
    options: [{label: message('Login page'), value: 'loginPage'}],
  },
};
